export enum ConversationResponseConfigureError {}
